var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"title-content"},[_c('icon',{staticStyle:{"margin-right":"10px","color":"#fe7f45"},attrs:{"custom":("iconfont " + _vm.icon),"size":"20"}}),_vm._v("\n    "+_vm._s(_vm.title)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }